import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Homepage page */
export default class HomePageOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired,
    setScroll: PropTypes.func.isRequired,
    homepage: PropTypes.string
  }


  componentDidMount () {
    document.body.classList.add('homepageBody')
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const { homepage } = this.props
    const debug = false
    return (
      <Joyride
        steps={this._steps(homepage)}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
        callback={evt => {
          if (evt.index === 2)
            this.props.setScroll()
          }
        }
        />
    )
  }

  _steps (homepage) {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs dashboard for {homepage}!<br /><br />This Networks & Platforms page illuminates a set of KPIs for network audiences by measuring key behaviors and preferences while benchmarking versus the relevant averages.<br /></p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>Portfolio analysis reveals the weight of engagement across top shows vs all original network content for last month.<br/><br/>Demographics break down the gender and age of the {homepage} audience.</p>),
        target: '#engangementComp'
      },
      {
        ...common,
        content: (<p>Genre analytics reveal the top genres favored by the {homepage} audience last month, measuring their engagement across all networks and platforms.<br/><br/>Click on the arrows at the top of the module to view genre preferences trended over time.</p>),
        target: '#genreComp'
      },
      {
        ...common,
        content: (<p>Viewership Overlap illuminates which other networks and platforms the {homepage} audience is spending time on. The percentage represents the proportion of the audience last month that also engaged with the listed network.<br/><br/>Let's Go!</p>),
        target: '#trendingComp'
      }
    ]

    return steps
  }
}
